import { getBranchAuthToken } from '@/assets/js/auth'
import HttpRequest from './HttpRequest'

class PatientProvider extends HttpRequest {
  getDataPatientAndOpd (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/patient/opd-patient', { ...query })
  }

  updatePatientOut (idAppoinment, idPatient) {
    this.setHeader(getBranchAuthToken())
    return this.patch(`/v1/appointment-schedule-patient/patient/${idAppoinment}/${idPatient}`)
  }

  getDataPatient (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/patient', { ...query })
  }

  getDataPatientByid (id) {
    this.setHeader(getBranchAuthToken())
    return this.get(`/v1/patient/${id}`)
  }

  createDataPatient (payload) {
    this.setHeader(getBranchAuthToken())
    return this.post('/v1/patient', payload)
  }

  updateDataById (id, payload) {
    this.setHeader(getBranchAuthToken())
    return this.patch(`/v1/patient/${id}`, payload)
  }

  deleteDataPatient (id) {
    this.setHeader(getBranchAuthToken())
    return this.delete(`/v1/patient/${id}`)
  }

  getMedicationHistoryPatient (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/patient-medication-history', { ...query })
  }

  getCourseHistoryPos (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/course-history-pos', { ...query })
  }

  getCourseHistory (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/course-history', { ...query })
  }

  getCheckingId (query) {
    this.setHeader(getBranchAuthToken())
    return this.get('/v1/patient/checking-id-card', { ...query })
  }
}

export default PatientProvider
